import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=481748ae&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=481748ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481748ae",
  null
  
)

export default component.exports